module.exports = __webpack_public_path__ + "static/lenvima-dose-reduction-mobile-bfac928572b39f9fbab35221a7e13063.png";